const IFRAME_CLEANUP_DELAY_MS = 1000;

/**
 * Opens the browser print dialog for a PDF blob.
 * @param {Blob} blob - PDF blob to print
 * @returns {Promise<void>}
 */
export const printPdfBlob = blob =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;

    let settled = false;

    const cleanup = () => {
      URL.revokeObjectURL(url);
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    };

    const finish = () => {
      if (settled) {
        return;
      }
      settled = true;
      cleanup();
      resolve();
    };

    iframe.onload = () => {
      try {
        const printWindow = iframe.contentWindow;
        if (!printWindow) {
          cleanup();
          reject(new Error('Print window not available'));
          return;
        }

        printWindow.addEventListener('afterprint', finish, { once: true });
        setTimeout(finish, IFRAME_CLEANUP_DELAY_MS);
        printWindow.print();
      } catch (error) {
        cleanup();
        reject(error);
      }
    };

    document.body.appendChild(iframe);
  });
